import type {GatewayError} from '@yandex-data-ui/gateway';

import {OrderDirection} from '~shared/models';

export enum PanelError {
    General = 'GENERAL',
    UserFeatureIsProcessing = 'USER_FEATURE_IS_PROCESSING',
}

export interface BasePanelState<Item, Filters extends object> {
    items: Item[];
    isFirstPage: boolean;
    nextCursor: string | null;
    /* determines if items are currently loading */
    loading: boolean;
    /* determines if more items are loaded (i.e. pagination) */
    loadingMore: boolean;
    error?: GatewayError;
    isEmpty: boolean;
    filters: {
        query: string;
        userFilter?: [];
    } & Filters;
    orderBy: string;
    orderDirection: OrderDirection;
}
